module.exports = __webpack_public_path__ + "static/media/clock.9e75a5f7.svg";